let siteContentEl = null;

function recalcDimensions() {
  if (siteContentEl === null) {
    siteContentEl = document.querySelector('.nst-siteContent') || false;
  }
  
  if (siteContentEl) {
    const contentStartY = siteContentEl.getBoundingClientRect().top + document.documentElement.scrollTop;
    document.documentElement.style.setProperty('--hac-contentStartY', contentStartY + 'px');
  }

  const fullWidth = document.body.clientWidth;
  document.documentElement.style.setProperty('--nst-viewportWidth', `${fullWidth}px`);
}

function watchDimensions() {
  if (document.readyState === 'complete') {
    recalcDimensions();
  }
  else {
    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', recalcDimensions);
    }
    
    window.addEventListener('load', recalcDimensions);
  }

  window.addEventListener('resize', recalcDimensions);
}

export default {
  recalcDimensions, watchDimensions
}